/**
 * Derive a concrete end date from an OCR duration phrase ("5 days",
 * "2 weeks", "1 month"). Anything fuzzier ("until told to stop") returns ""
 * so the field stays empty for the user to confirm. A duration of "N days"
 * means the course covers N dosing days starting on startDate; date
 * arithmetic is done in UTC so the result is timezone-independent (#2220).
 */
export function endDateFromDuration(
  startDate: string,
  duration: string,
): string {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(startDate)) return "";
  const match = duration
    .trim()
    .toLowerCase()
    .match(/^(\d+)\s*(day|week|month)s?$/);
  if (!match) return "";
  const count = Number(match[1]);
  if (!count) return "";
  const date = new Date(`${startDate}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return "";
  if (match[2] === "day") {
    date.setUTCDate(date.getUTCDate() + count - 1);
  } else if (match[2] === "week") {
    date.setUTCDate(date.getUTCDate() + count * 7 - 1);
  } else {
    // Month courses end on the same calendar day N months later, clamped to
    // the target month's last day (Jan 31 + 1 month → Feb 28, not Mar 3).
    const day = date.getUTCDate();
    date.setUTCDate(1);
    date.setUTCMonth(date.getUTCMonth() + count);
    const lastDay = new Date(
      Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0),
    ).getUTCDate();
    date.setUTCDate(Math.min(day, lastDay));
  }
  return date.toISOString().slice(0, 10);
}
